module.exports = __webpack_public_path__ + "img/checkbox_rounded_unchecked.5f75dc1.png";